import * as S from './style';

export interface TooltipWeekendWorkProps {
  message: string;
  $x: number;
  $y: number;
  $opacity: number;
}

export default function TooltipWeekendWork({ $x, $y, $opacity, message }: TooltipWeekendWorkProps) {
  return (
    <S.Wrapper $x={$x} $y={$y} $opacity={$opacity}>
      {message}
    </S.Wrapper>
  );
}
